// 导出配置的路由器
export default [{
        path: '/systemManagement',
        component: () =>
            import ('@/layout/index'),
        redirect: 'systemManagement/systemParamManage',
        meta: {
            title: '系统管理',
            icon: 'icon-xitong',
            perms: ['bee:system']
        },
        children: [
         /* {
                path: 'systemParamManage',
                component: () =>
                    import ('@/module/maintenanceCenter/page/systemParam/manage.vue'),
                meta: { icon: 'icon-shebei2', title: '系统参数', perms: ['bee:ops:systemParam'] }
            },
            {
                path: 'paymentType',
                component: () =>
                    import ('@/module/systemManagement/page/paymentType/manage.vue'),
                meta: {
                    title: '支付方式',
                    icon: 'icon-jifen2',
                    perms: ['bee:system:paymentType']
                }
            },*/
            {
                path: 'authorityManagement',
                component: () =>
                    import ('@/module/systemManagement/page/authority/manage.vue'),
                meta: {
                    title: '子账号管理',
                    icon: 'icon-quanxian3',
                    perms: ['bee:system:user']
                }
            },
     /*       {
              path: 'appAuthorityManagement',
              component: () =>
                import ('@/module/systemManagement/page/appAuthority/manage.vue'),
              meta: {
                title: '子账号管理',
                icon: 'icon-quanxian3',
                perms: ['bee:system:user']
              }
            },*/
          /*  {
                path: 'userPayment',
                component: () =>
                    import ('@/module/systemManagement/page/userPayment.vue'),
                meta: {
                    title: '支付渠道管理',
                    icon: 'icon-shangjia',
                    perms: ['bee:pay:operatorPayment']
                }
            },
            {
                path: 'systemLogInfoManager',
                component: () =>
                    import ('@/module/systemManagement/page/systemLogInfo/manage.vue'),
                meta: {
                    title: '操作日志',
                    icon: 'icon-caozuo',
                    perms: ['bee:system:systemLogInfo']
                }
            },*/
            // {
            //   path: 'personalSettings',
            //   component: () => import('@/module/systemManagement/page/personalSettings.vue'),
            //   hidden: true,
            //   meta: {
            //     title: '个人设置',
            //     icon: 'icon-geren'
            //   }
            // }
        ]
    },
  {
        path: '/personalCenter',
        component: () =>
            import ('@/layout/index'),
        redirect: 'personalCenter/personalSettings',
        hidden: true, //隐藏
        meta: {
            title: '个人中心',
            icon: 'icon-geren'
        },
        children: [{
            path: 'personalSettings',
            name: 'personalSettings',
            component: () =>
                import ('@/module/systemManagement/page/personalSettings.vue'),
            meta: {
                title: '个人设置',
                icon: 'icon-caozuo'
            }
        }]
    }
]



// WEBPACK FOOTER //
// ./src/module/systemManagement/router/index.js